<template>
  <v-container fluid px-0 id="available-shifts-container">
    <v-layout column>
      <v-flex>
        <h1 class="text-xs-center mb-3 subtle grey lighten-2 all-caps">Available Shifts</h1>
      </v-flex>

      <!--
      <v-layout v-if="future.length == 0" row justify-center class="text-xs-center">
        <v-flex grow>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      -->
      <v-layout row wrap align-content-space-between class="shifts-list">
        <v-flex v-for='item in shifts.slice(0,3)' :key='item.id' class="md4 sm12 pa-1">
          <v-card v-if="!item.userId" class="shift-card mb-2">
            <v-card-title>
              <ShiftItem
                showIcon
                :pickupable="!item.userId"
                :itemData='item'
              />
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShiftItem from '@/components/dashboard/shift-item.vue'

export default {
  mounted () {
  },
  created () {
    this.fetchData()
    this.fetchAvailableShifts()
  },
  components: {
    ShiftItem
  },
  computed: {
    // ...mapGetters('shifts', [
    //   'available'
    // ]),
    ...mapState('userAuth', [
      'user'
    ]),
    // future: function() {
    //   return this.available.filter(shift => { 
    //     return this.$moment(shift.startDatetime).isAfter() 
    //   })
    // }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('calendar/getShiftsInDates', {
        userId: this.user.id,
        start: this.$moment().valueOf(),
        end: this.$moment().add(10, 'days').valueOf()
      })
    },
    fetchAvailableShifts () {
      this.$store.dispatch('shifts/getCurrentUserPickupable')
      .then((res) => this.shifts = res); 
      return this.shifts.filter(shift => { 
        return this.$moment(shift.startDatetime).isAfter() 
      })
    },
  },
  data: function () {
    return {
      shifts: [],
    }
  }
}
</script>

<style scoped>
/* #available-shifts-container {
  position: absolute;
  bottom: 0;
} */

.shift-details {
  font-size: 0.75em;
}
.shifts-list {
  overflow-x: scroll;
}
</style>
